



























import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ListMixin } from '@/mixins/list.mixin'
import { Column } from 'ant-design-vue/types/table/column'
import Filters from '@/components/filters/Filters.vue'
import { Filter, FilterTypes } from '@/interfaces/filter'

@Component({
  components: {
    Filters
  }
})
export default class CoursesView extends mixins(ListMixin) implements ListMixin {
  apiConfig = {
    path: 'courses'
  }

  filters: Filter[] = [
    {
      name: 'externalId',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'External ID'
      }
    },
    {
      name: 'forms.externalId',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'External ID формы'
      }
    },
    {
      name: 'name',
      condition: '$contL',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'Название'
      },
      span: 6
    },
    {
      name: 'site',
      condition: '$contL',
      type: FilterTypes.INPUT,
      input: {
        placeholder: 'Сайт'
      }
    }
  ]

  columns: Partial<Column>[] = [
    {
      dataIndex: 'externalId',
      title: 'External ID'
    },
    {
      dataIndex: 'name',
      title: 'Название'
    },
    {
      dataIndex: 'category.name',
      title: 'Категория'
    },
    {
      dataIndex: 'site',
      title: 'Сайт'
    }
  ]
}
